import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import CoursesSection from './components/CoursesSection';
import HowClassesWorkSection from './components/HowClassesWorkSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

export default function Home() {
  return (
    <main className="relative w-full overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <PhilosophySection />
      <CoursesSection />
      <HowClassesWorkSection />
      <div className="w-full bg-white flex">
        <img
          src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/769184e18ec7623be525f80f2b91de7d.png"
          alt="Ilustração de instrumentos musicais - Guitarra, bateria, vinil, clave de sol e piano"
          title="Instrumentos musicais - TL Artes & Música"
          className="w-1/2 h-20 sm:h-24 md:h-28 lg:h-32 object-cover object-left"
        />
        <img
          src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/769184e18ec7623be525f80f2b91de7d.png"
          alt="Ilustração de instrumentos musicais - Guitarra, bateria, vinil, clave de sol e piano"
          title="Instrumentos musicais - TL Artes & Música"
          className="w-1/2 h-20 sm:h-24 md:h-28 lg:h-32 object-cover object-right"
        />
      </div>
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}